export const DEFAULT_USER_DISPLAY_LANGUAGE = 'en-US';
export const DEFAULT_USER_LANGUAGE = 'en-US';
export const DEFAULT_USER_FORCE_LANGUAGE_OVERRIDE = 'false';

export const INT32_MAX_NUMBER = 2147483647;

/**
 * Maps timezone offsets to DST-free IANA timezone identifiers.
 * Uses Etc/GMT format for hour offsets (note: Etc/GMT has inverted signs).
 * For fractional hour offsets, uses IANA zones that don't observe DST where available.
 * Some fractional offsets don't have DST-free alternatives and will observe DST.
 */
export const TIMEZONE_OFFSET_TO_IANA: Record<string, string> = {
  '-12:00': 'Etc/GMT+12',
  '-11:00': 'Etc/GMT+11',
  '-10:00': 'Etc/GMT+10',
  '-09:30': 'Pacific/Marquesas', // No DST
  '-09:00': 'Etc/GMT+9',
  '-08:00': 'Etc/GMT+8',
  '-07:00': 'Etc/GMT+7',
  '-06:00': 'Etc/GMT+6',
  '-05:00': 'Etc/GMT+5',
  '-04:00': 'Etc/GMT+4',
  '-03:30': 'America/St_Johns', // DST will apply - no DST-free alternative for -03:30
  '-03:00': 'Etc/GMT+3',
  '-02:00': 'Etc/GMT+2',
  '-01:00': 'Etc/GMT+1',
  '+00:00': 'Etc/GMT',
  '+01:00': 'Etc/GMT-1',
  '+02:00': 'Etc/GMT-2',
  '+03:00': 'Etc/GMT-3',
  '+03:30': 'Asia/Tehran', // DST will apply - no DST-free alternative for +03:30
  '+04:00': 'Etc/GMT-4',
  '+04:30': 'Asia/Kabul', // No DST
  '+05:00': 'Etc/GMT-5',
  '+05:30': 'Asia/Kolkata', // No DST
  '+05:45': 'Asia/Kathmandu', // No DST
  '+06:00': 'Etc/GMT-6',
  '+06:30': 'Asia/Yangon', // No DST
  '+07:00': 'Etc/GMT-7',
  '+08:00': 'Etc/GMT-8',
  '+08:45': 'Australia/Eucla', // No DST
  '+09:00': 'Etc/GMT-9',
  '+09:30': 'Australia/Darwin', // No DST
  '+10:00': 'Etc/GMT-10',
  '+10:30': 'Australia/Lord_Howe', // DST will apply - no DST-free alternative for +10:30
  '+11:00': 'Etc/GMT-11',
  '+12:00': 'Etc/GMT-12',
  '+12:45': 'Pacific/Chatham', // DST will apply - no DST-free alternative for +12:45
  '+13:00': 'Etc/GMT-13',
  '+14:00': 'Etc/GMT-14'
};
